import {WINTYPE} from "@nolimitcity/promo-panel/bin/enums/ASEnums";
import {
    ActionSpinOptions,
    ActionSpinSound,
    ASWinData, IResponseData,
    PromoPanelGameConfiguration
} from "@nolimitcity/promo-panel/bin/interfaces/ASInterfaces";
import {XwaysHoarder2Sound} from "./sound/XwaysHoarder2Sound";
import {MathHelper} from "@nolimitcity/slot-game/bin/utils/MathHelper";
import {XwaysHoarder2GameAssets} from "./XwaysHoarder2GameAssets";
import {XwaysHoarder2GameData} from "./server/XwaysHoarder2Data";
import {GameMode} from "@nolimitcity/slot-game/bin/flowcontrol/GameMode";
import {XW2GameMode, XwaysHoarder2} from "./XwaysHoarder2";

export class XwaysHoarder2PromoPanelConfig implements PromoPanelGameConfiguration {
    constructor() {
    }

    public getActionSpinOptions(): ActionSpinOptions {
        return {
            hasActionSpin: true,
            gameName: "XwaysHoarder2",
            graphics: {
                backgroundTextureName: XwaysHoarder2GameAssets.MAIN_GAME_BACKGROUND
            },
            getParsedData: (response: XwaysHoarder2GameData, bet: number, prevResponse: XwaysHoarder2GameData): ASWinData => {
                const parsedData: ASWinData = {
                    totalWin: response.accumulatedRoundWin,
                    wasFeatureBuy: response.wasFeatureBuy,
                    freeSpinTriggeredThisSpin: this.ifFreeSpinTriggeredThisSpin(response),
                    totalSpinWinnings: response.totalSpinWinnings,
                    isBigWin: this.isBigWin(response),
                    winType: WINTYPE.NORMAL,
                    featureName: this.getFeatureName(response),
                    isRoundComplete: this.isRoundComplete(response),
                    isBonusEnd: this.isBonusEnd(response),
                    isWinCapHit: false,

                }
                return parsedData;
            }
        };

    }

    isLegalStopOnBonusMode(response: IResponseData): boolean {
        return response.nextMode !== GameMode.RESPIN;
    }



    public onActionSpinPlaySound(trigger: ActionSpinSound): void {
        if (trigger == ActionSpinSound.WIN) {
            XwaysHoarder2Sound.playTrack(XwaysHoarder2Sound.AS_WIN);
        } else if (trigger == ActionSpinSound.BIG_WIN) {
            XwaysHoarder2Sound.playTrack(XwaysHoarder2Sound.AS_WIN_BIG);
        }
    }


    private ifFreeSpinTriggeredThisSpin(response: XwaysHoarder2GameData): boolean {
        return ((response.mode === "NORMAL" || response.mode === "RESPIN") && (response.nextMode === "FREESPIN" || response.nextMode === "SUPER_FREESPIN"));
    }

    private isBigWin(response: XwaysHoarder2GameData): boolean {
        let win: number = response.totalSpinWinnings;

        let winRatio: number = MathHelper.floorToDecimals((win / response.playedBetValue), 2);

        if (response.wasFeatureBuy || response.boostedBet) {
            const betPrice: number = XwaysHoarder2.getBuyFeaturePrice();
            if (XwaysHoarder2.buyFeatureName !== "BOOSTED_BET_1" && XwaysHoarder2.buyFeatureName !== "BOOSTED_BET_2") {
                winRatio = MathHelper.floorToDecimals((win / betPrice), 2);
            }
            return response.wasFeatureBuy ? winRatio >= 1 : (XwaysHoarder2.buyFeatureName === "BOOSTED_BET_1" || XwaysHoarder2.buyFeatureName === "BOOSTED_BET_2") ? winRatio >= 15 : winRatio >= 1;
        }

        return winRatio >= 15;
    }

    private getFeatureName(response: XwaysHoarder2GameData): string {
        let modeName: string = "";
        if (response.nextMode === GameMode.RESPIN || response.mode === GameMode.RESPIN) {
            if (response.mode === GameMode.RESPIN && (response.nextMode !== GameMode.NORMAL && response.nextMode !== GameMode.RESPIN)) {
                if (response.nextMode === "SUPER_FREESPIN") {
                    if (response.nextFSLevel === 4) {
                        modeName = "BINGE SPINS";
                    } else {
                        modeName = "PLUNDER SPINS"
                    }
                } else if (response.nextMode === "FREESPIN") {
                    modeName = "RAID SPINS"
                }
            } else {
                modeName = "LOOT SPINS";
            }
        } else {
            if (response.mode === XW2GameMode.SUPER_FREESPIN) {
                if (response.currentFSLevel === 4) {
                    modeName = "BINGE SPINS";
                } else {
                    modeName = "PLUNDER SPINS"
                }
            } else if (response.nextMode === XW2GameMode.SUPER_FREESPIN) {
                if (response.nextFSLevel === 4) {
                    modeName = "BINGE SPINS";
                } else {
                    modeName = "PLUNDER SPINS"
                }
            }
            if (response.mode === GameMode.FREESPIN) {
                if (response.currentFSLevel === 4) {
                    modeName = "BINGE SPINS";
                } else {
                    modeName = "RAID SPINS"
                }
            } else if (response.nextMode === GameMode.FREESPIN) {
                if (response.nextFSLevel === 4) {
                    modeName = "BINGE SPINS";
                } else {
                    modeName = "RAID SPINS"
                }
            }
        }
        return modeName;
    }

    private isRoundComplete(response: XwaysHoarder2GameData): boolean {
        return [GameMode.NORMAL, XW2GameMode.SUPER_FREESPIN, GameMode.FREESPIN].indexOf(response.nextMode) > -1;
    }

    private isBonusEnd(response: XwaysHoarder2GameData): boolean {
        return response.nextMode === GameMode.NORMAL && (response.mode === GameMode.FREESPIN || response.nextMode === XW2GameMode.SUPER_FREESPIN);
    }


}